export const DEACTIVATION_LABELS = {
    EMPLOYEE: {
        TITLE: 'Деактивувати працівника',
        CONFIRM: 'Деактивувати працівника',
        CANCEL: 'Скасувати деактивацію',
        BODY_SUFFIX: 'Після деактивації працівник завершає співпрацю і переходить в архів.'
    },
    CHILD: {
        TITLE: 'Деактивувати дитину',
        CONFIRM: 'Деактивувати дитину',
        CANCEL: 'Скасувати деактивацію',
        BODY_SUFFIX: 'Після деактивації дитина перестане відображатися у вкладці активних і перейде в архів неактивних.'
    }
};
